import React, { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import TextField from '@mui/material/TextField';
import { IconButton, Box, Button } from '@mui/material/';
import InvalidPrompt from "./invalidSrcDstPrompt.js";
import StarBorderIcon from '@mui/icons-material/StarBorder';
import { uds } from '../services/userservices';
import { auth } from '../firebase';

var apiPrefix = '';
export const getAPIPrefix = () => apiPrefix;

const hostname = window.location.hostname;

if (hostname === 'localhost') {
    apiPrefix = 'http://localhost:5000';
} else if (hostname === 'https://ontimeucsc.netlify.app') {
    apiPrefix = 'https://on-time-6389001ec39c.herokuapp.com';
} else {
    apiPrefix = 'https://on-time-6389001ec39c.herokuapp.com';
}

export default function NumberInput({ onButtonClick, building }) {
    const [searchParams, setSearchParams] = useSearchParams();
    const [src, setSource] = useState(searchParams.get('src') ?? '');
    const [dst, setDestination] = useState(searchParams.get('dst') ?? '');
    const [invalidSubmission, setInvalidSubmission] = useState(false);
    
    const favorite = () => {
        const user = auth.currentUser;
        if (user) {
            const b = window.location.pathname.replace('/', '');
            uds.addFavorite(user.uid, `${b} ${src} ${dst}`);
            console.log(`added ${src} ${dst}`);
        }
    }

    const handleSourceChange = (event) => {
        const inputValue = event.target.value.replace(/[^A-Za-z0-9]/g, '').toUpperCase(); // Allow only capitalized letters and numbers
        setSource(inputValue);
    };

    const handleDestinationChange = (event) => {
        const inputValue = event.target.value.replace(/[^A-Za-z0-9]/g, '').toUpperCase(); // Allow only capitalized letters and numbers
        setDestination(inputValue);
    };

    const handleBadSubmission = () => {
        console.log('here');

        setInvalidSubmission(true);
    };


    const handleButton = async () => {
        console.log("apiprefix = ", apiPrefix)
        try {
            const response = await fetch(`${apiPrefix}/pathfinding?building=${encodeURIComponent(building)}&src=${encodeURIComponent(src)}&dst=${encodeURIComponent(dst)}`, {
                // mode: 'no-cors',
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
            });
            // console.log("response = ", )
            if (!response.ok) throw response;
            if (response.ok) {
                setInvalidSubmission(false);
                const content = await response.json(); // assuming the response is in JSON format
                const arrayLength = content.length
                onButtonClick({ content, arrayLength });
            } else {
                console.error('Failed to fetch path from the server.');
                handleBadSubmission();
            }
        } catch (error) {
            handleBadSubmission();
            console.error('Error fetching path from the server:', error);
        }
    };

    return (
        <Box marginLeft={2} marginTop={2}>
            {invalidSubmission && <InvalidPrompt />}

            <Box mb={2}>
                <TextField
                    label="Current Location"
                    type="text"
                    placeholder="Enter Room Number"
                    value={src}
                    onChange={handleSourceChange}
                    InputLabelProps={{
                        shrink: true,
                    }}
                />
            </Box>
            <Box mb={2}>
                <TextField
                    label="Destination"
                    type="text"
                    placeholder="Enter Room Number"
                    value={dst}
                    onChange={handleDestinationChange}
                    InputLabelProps={{
                        shrink: true,
                    }}
                />
            </Box>
            <Button variant="contained" onClick={handleButton}>
                Search
            </Button>
            <IconButton onClick={favorite} aria-label="favorite" color="primary" style={{marginLeft: "100px"}}>
                <StarBorderIcon />
            </IconButton>
        </Box>
    );
}
